module.exports = __webpack_public_path__ + "img/pigment_5.99af2fe8.png";